/**
 * Rakenne Vyöhykkeet row chrome: dirty Tallenna/Peruuta + collapsed Tyyppi copy.
 */
import { dirty_actions_visible } from "@/components/building/shared/one-open-accordion";

export { dirty_actions_visible };

export type ZoneStructureDraft = {
  name: string;
  floor: number;
  zone_type: string;
  description: string;
};

export function zone_draft_from_card(zone: {
  name: string;
  floor: number;
  zone_type: string | null;
  description: string;
}): ZoneStructureDraft {
  return {
    name: zone.name,
    floor: zone.floor,
    zone_type: zone.zone_type ?? "",
    description: zone.description,
  };
}

export function is_zone_draft_dirty(
  draft: ZoneStructureDraft,
  saved: ZoneStructureDraft,
): boolean {
  return (
    draft.name.trim() !== saved.name.trim() ||
    draft.floor !== saved.floor ||
    draft.zone_type !== saved.zone_type ||
    draft.description.trim() !== saved.description.trim()
  );
}

export function discard_zone_draft(
  saved: ZoneStructureDraft,
): ZoneStructureDraft {
  return { ...saved };
}

export function zone_type_collapsed_value(
  kb_zone_types: readonly { id: string; name_fi: string }[],
  zone_type: string,
): string {
  const match = kb_zone_types.find((zt) => zt.id === zone_type);
  return match?.name_fi ?? (zone_type || "—");
}
